import styles from "./CommonHeader.module.css";

const CommonHeader = () => {
  return (
    <header className={styles.header}>
      <span>リフト撮影サービス</span>
    </header>
  );
};
export default CommonHeader;
